import React from "react";
import DataTable from '../../DataTable/DataTable';
import clsx from 'clsx';
import DateHelper from "../../DateHelper/DateHelper";

class ProductFolioItemPresenterGeneral extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00',
    }
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    })
    
    // if (this.props.taxes && this.props.taxes.length) {
    //   var taxes = this.props.taxes.map((tax) => {
    //     return <li key={tax.id}>{tax.name}</li>
    //   })
    // } else {
    //   var taxes = null
    // };

    var folio_item = {
      subtotal: this.props.amount,
      total_amount: this.props.amount * this.props.quantity,
      folio_id: this.props.folio ? this.props.folio.id : null,
      item_date: this.props.item_date,
      product_id: this.props.product ? this.props.product.id : null,
      quantity: this.props.quantity,
      rate_id: this.props.rate ? this.props.rate.id : null,
      guest_type_id: this.props.guest_type ? this.props.guest_type.id : null,
      room_type_id: this.props.room_type ? this.props.room_type.id : null,
      fee_id: this.props.fee ? this.props.fee.id : null,
    }

    return(
      <div className={tabClasses} id="general">
        {
          this.props.edit ? 
            <div className="alert alert-primary">{I18n.t('posted_folio_item_warning')}</div>
          : 
          null
        }

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <div className="panel panel-default">
                <div className="panel-body container">
                  <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10 }}>{I18n.t('item_details')}</h5>
                  <div className="row">
                    <div className="col-sm-3">
                      <label>{I18n.t('item_type')}</label>
                      <div>{this.props.product ? this.props.product.name : I18n.t(this.props.item_type.name)}</div>
                    </div>

                    <div className="col-sm-3">
                      <label>{I18n.t('item_date')}</label>
                      <div>{DateHelper.printDateToScreen(this.props.item_date, this.props.date_format)}</div>
                    </div>

                    <div className="col-sm-3">
                      <label>{I18n.t('status')}</label>
                      <div>{I18n.t(this.props.status)}</div>
                    </div>
                 
                    <div className="col-sm-3">
                      <label>{I18n.t('folio')}</label>
                      <div>{this.props.folio.name}</div>
                    </div>
                  
                 

                  </div>
                  <br />
                  <div className="row">
                    <div className="col-sm-3">
                      <label>{I18n.t('created_by')}</label>
                      <div>{this.props.folio_item_source}</div>
                    </div>

                    <div className="col-sm-3">
                      <label>{I18n.t('created_at')}</label>
                      <div>{DateHelper.printDateToScreen(this.props.created_at, this.props.date_format)}</div>
                    </div>
                    <div className="col-sm-3">
                      <label>{I18n.t('updated_by')}</label>
                      <div>{this.props.updated_by}</div>
                    </div>
                    <div className="col-sm-3">
                      <label>{I18n.t('last_updated')}</label>
                      <div>{DateHelper.printDateToScreen(this.props.updated_at, this.props.date_format)}</div>
                    </div>
                 
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <div className="panel panel-default">
                <div className="panel-body container">
                  <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10 }}>{I18n.t('item_amount')}</h5>
                  <div className="row">
                    <div className="col-sm-6 form-group">
                      <label>{I18n.t('amount')}</label>
                      <div>{this.props.formatCurrency(this.props.amount)}</div>
                    </div>
                    <div className="col-sm-6 form-group">
                      <label>{I18n.t('quantity')}</label>
                      <div>{this.props.quantity}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
   
        </div>

        {
          !this.props.edit_booking
            ?
          <div>
            <h5 className="panel-heading-text" style={{ paddingBottom: 20, paddingTop: 10 }}>{I18n.t('taxes_and_fees')}</h5>
            <div className="panel panel-default">
              <div className="panel-body container">
                {/* {
                  this.props.folio_item.status 
                } */}
                <DataTable
                  endpoint = {this.props.children_data_table_path}
                  folio_item = {folio_item ? folio_item : null}
                  reservation_segment_guest_types={this.props.reservation_segment && this.props.reservation_segment.reservation_segment_guest_types ? this.props.reservation_segment.reservation_segment_guest_types : null}
                  calculate_taxes_and_fees= {this.props.calculate_taxes_and_fees ? "inclusive" : "exclusive"}
                  item_type= {this.props.item_type ? this.props.item_type.name : null}
                  tax_ids= {this.props.tax_ids}
                  fee_ids= {this.props.fee_ids}
                  no_data_text = {I18n.t('none')}
                  currency_unit = {I18n.t('number.currency.format.unit')}
                  delimiter = {I18n.t('number.currency.format.delimiter')}
                  separator = {I18n.t('number.currency.format.separator')}
                  date_format = {this.props.date_format}
                  time_format = {this.props.time_format}
                  read_only = {this.props.read_only}
                />
              </div>
            </div>
          </div>
            :
          null
        }

      </div>

    );
  };
};

export default ProductFolioItemPresenterGeneral